import React from 'react';

const createReactClass = require('create-react-class');

const QuoteRotator = createReactClass({
  getInitialState() {
    return { currentQuote: 0 };
  },
  incrementQuote() {
    this.setState({
      currentQuote: (this.state.currentQuote + 1) % this.props.quotes.length
    });
  },
  componentDidMount() {
    this.intervalId = setInterval(this.incrementQuote, this.props.interval);
  },
  componentWillUnmount() {
    clearInterval(this.intervalId);
  },
  render() {
    const quote = this.props.quotes[this.state.currentQuote];
    return (
      <blockquote>
        {quote.text}
        <cite>&mdash; {quote.cite}</cite>
      </blockquote>
    );
  }
});

QuoteRotator.defaultProps = {
  interval: 7000
};

export { QuoteRotator };
